module.exports = __webpack_public_path__ + "media/images/application/template/logos/iso-9001-2022-fab16c901fe35266ca44416d4969a0b1.png";